(function (app) {

	function escapeUnIntCid(search) {
		var search = decodeURIComponent(search),
			params = search.split("&"),
			cidStr = '',
			cidValue = '';
		if (params.length > 0 && params[0]) {
			for (var i = 0; i < params.length; i++) {
				cidStr = params[i].match(/cid=\w+/);
				if (params[i].match(/cid=\w+/)) {
					cidValue = params[i].match(/cid=(\w+)/);
				}
			}
			if (cidValue && cidValue[1] % 1 !== 0) {
				return search.replace(cidStr[0], "cid=10");
			}
		}
		return window.location.search;
	}

	function getGoMobileLink() {
		return location.protocol + '//' + window.location.host.replace('www', 'm') + window.location.pathname + escapeUnIntCid(window.location.search) + window.location.hash;
	}

	$(function () {
		var fullWebSiteCookie = !!app.cookie.get('UseFullWebSite'),
			goMobileLink = getGoMobileLink(),
			linkGoMobile = $('.header-menu-link-go-mobile, .bottom-menu-go-mobile');

		linkGoMobile
			.toggle(fullWebSiteCookie)
			.attr('href', goMobileLink)
			.on('click', function () {
				app.cookie.set('UseFullWebSite', 0, 24 * 365);
				window.location.assign(goMobileLink);
			});

		$(window).bind('hashchange', function () {
			linkGoMobile.attr('href', getGoMobileLink());
		});
	});
})(app);